import React, { useState, useEffect } from "react";
import Footer from "../../Hoc/Footer";
import Header from "../../Hoc/Header";
import styles from "./consType.module.css";
import phoneCons from "../../../Assets/img/telephone.png";
import conv from "../../../Assets/img/conversation.png";
import axios from "axios";
import { useNavigate } from "react-router-dom";

function ConsTypeSelect() {
  const navigate = useNavigate();
  const [user, setUser] = useState([]);

  useEffect(() => {
    axios
      .get(
        `https://arianaapp.arianaapply.com/api/V1/get-user/${localStorage.getItem(
          "token"
        )}`
      )
      .then((response) => {
        console.log("user", response.data);
        setUser(response.data);
      })
      .catch((err) => console.log(err));
  }, []);

  const checkPayment = () => {
    axios
      .post(
        `https://arianaapp.arianaapply.com/api/V1/check-payment-non-free-consultation`,
        {
          user_id: user._id,
        }
      )
      .then((res) => {
        console.log(res);
        if (res.data.status === 401) {
          navigate("/cons-payment");
        } else {
          navigate("/cons-paid");
        }
      })
      .catch((err) => {
        console.log(err.response);
      });
  };

  return (
    <main className={styles.main}>
      <Header title="فرم مشاوره" />
      <div className={styles.mainBody}>
        <div className={styles.consTypes}>
          <div
            className={styles.consType}
            onClick={() => navigate("/free-consulting")}
          >
            <div className={styles.consImage}>
              <img src={phoneCons} alt="" />
            </div>
            <div className={styles.consTypeText}>
              <h2>مشاوره اوليه رايگان</h2>
              <p>
                اگه تابحال با كارشناسان ما مشاوره نشدي اطلاعاتت رو ثبت كن و
                رايگان مشاوره شو
              </p>
            </div>
          </div>

          <div className={styles.consType} onClick={checkPayment}>
            <div className={styles.consImage}>
              <img src={conv} alt="" />
            </div>
            <div className={styles.consTypeText}>
              <h2>مشاوره تخصصی</h2>
              <p>
                اگه ميخوای از كارشناسان ارشد ما مشاوره تخصصی بگيری با پرداخت 200
                هزار تومان ميتونی درخواستت رو ثبت كنی
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer active="cons" />
    </main>
  );
}

export default ConsTypeSelect;